export class Queue {
    constructor () {
        this._items = [];
    }

    enqueue (item) {
        this._items.push(item);
    }

    dequeue () {
        return this._items.shift();
    }

    clear () {
        this._items = [];
    }

    size () {
        return this._items.length;
    }
}
